import { render, staticRenderFns } from "./siteBase.vue?vue&type=template&id=6049c04c&"
import script from "./siteBase.vue?vue&type=script&lang=js&"
export * from "./siteBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports